import { z } from 'zod';

/**
 * Parse + validate env against a zod schema, failing fast with a readable error.
 * Each app defines its own schema and calls this at boot.
 */
export function parseEnv<T extends z.ZodTypeAny>(
  schema: T,
  runtimeEnv: Record<string, unknown> = process.env,
): z.infer<T> {
  const parsed = schema.safeParse(runtimeEnv);
  if (!parsed.success) {
    const issues = parsed.error.issues
      .map((i) => `  - ${i.path.join('.') || '(root)'}: ${i.message}`)
      .join('\n');
    throw new Error(`Invalid environment variables:\n${issues}`);
  }
  return parsed.data;
}
